var _rect, _rect2, _rect3, _rect4, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.184138,
    y: 0.11473,
    width: 19.7734,
    height: 9.42163,
    rx: 1.07386,
    transform: "matrix(0.97408 -0.226206 0.226227 0.974075 3.67804 4.52412)",
    fill: "#A1E5AD",
    stroke: "#242D41",
    strokeWidth: 0.306818
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.164851,
    y: 0.141043,
    width: 20.5092,
    height: 9.55323,
    rx: 1.07386,
    transform: "matrix(0.996985 -0.0775906 0.0775983 0.996985 4.49736 5.16263)",
    fill: "#A1E5AD",
    stroke: "#242D41",
    strokeWidth: 0.306818
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.24432,
    y: 6.27947,
    width: 25.7727,
    height: 21.4762,
    rx: 3.78409,
    fill: "#A38079",
    stroke: "#242D41",
    strokeWidth: 0.613636
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 3.13583,
    y: 8.17196,
    width: 21.9886,
    height: 17.6923,
    rx: 3.11932,
    stroke: "#242D41",
    strokeWidth: 0.306818,
    strokeDasharray: "0.61 0.61"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1925 17.0186C19.1925 15.6913 20.2685 14.6153 21.5958 14.6153H28.2436C28.6108 14.6153 28.9084 14.913 28.9084 15.2801V18.7571C28.9084 19.1243 28.6108 19.4219 28.2436 19.4219H21.5958C20.2685 19.4219 19.1925 18.3459 19.1925 17.0186Z",
    fill: "#AF9690",
    stroke: "#242D41",
    strokeWidth: 0.306818
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7457 17.018C22.7457 17.6534 22.2306 18.1685 21.5952 18.1685C20.9597 18.1685 20.4446 17.6534 20.4446 17.018C20.4446 16.3826 20.9597 15.8675 21.5952 15.8675C22.2306 15.8675 22.7457 16.3826 22.7457 17.018Z",
    fill: "#876761",
    stroke: "#242D41",
    strokeWidth: 0.357955
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.c39fa3d0e6516127c8166e22125f0cf0.svg";
export { ForwardRef as ReactComponent };